export class Cookies{
	init(){		
		var self = this;
		$(document).ready(function () {
			
			if (self.getCookie("cookie_agree") == 1){
				$('.cookies-tab').hide();      
			}else {
				$('.cookies-tab').show();      
			}

			$('.cookies-tab .button').click(function () {
				self.cookieAgree();
				return false;
			});
                    if (self.getCookie("promotion") != 1){
                        setTimeout(function(){
                            $('.promoted-product-modal-wrapper').fadeIn();
                        },1500);
                    }
                    $('.promoted-product-modal-wrapper .close-button').on('click',function(){
                        self.setCookie("promotion", 1, 7);
                        $('.promoted-product-modal-wrapper').fadeOut();
                    });
                });
                

	}
	cookieAgree(){
		var self = this;
		self.setCookie("cookie_agree", 1, 365);
		$('.cookies-tab').fadeOut(400);
	}
	getCookie(name) {
	    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
	    return v ? v[2] : null;
	}
	setCookie(name, value, days) {
	    var d = new Date;
	    d.setTime(d.getTime() + 24*60*60*1000*days);
	    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
	}
        
}